import { useTranslation } from "react-i18next";

import { FormikProps } from "formik";

import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { nameof } from "../../../../../../utils/nameof";
import { FieldWithInfo } from "../../../personal-data/components/field-with-info/FieldWithInfo";
import { PropertyRightsFormValues } from "../../OtherPropertyRightsView.types";
import { PropertyRightKindConfig, withEntryAnswered } from "../../OtherPropertyRightsView.utils";

const TAB = "clients.client.debtSettlement.assetInventory.propertyRightsTab";
const RIGHTS_FIELD = nameof<PropertyRightsFormValues>("propertyRights");

interface Props {
  formik: FormikProps<PropertyRightsFormValues>;
  config: PropertyRightKindConfig;
  info?: string;
}

export function EntryQuestion({ formik, config, info }: Props) {
  const { t } = useTranslation();
  const label = t(`${TAB}.${config.translationKey}.entryQuestion`);

  const question = (
    <FormikYesNoAutocomplete
      id={`property-rights-${config.entryField}`}
      formik={formik}
      path={`answers.${config.entryField}`}
      label={label}
      disableClearable
      onValueChange={(value) =>
        void formik.setFieldValue(RIGHTS_FIELD, withEntryAnswered(formik.values.propertyRights, config.kind, value))
      }
    />
  );

  return info ? (
    <FieldWithInfo fieldLabel={label} info={info}>
      {question}
    </FieldWithInfo>
  ) : (
    question
  );
}
